/**
 * @generated SignedSource<<8b8ce1d6dbeb9424f3180fb2a6dc3c58>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type AdGeneratorInput = {
  ctaText?: string | null;
  customPrompt?: string | null;
  effectPreset?: string | null;
  formatPreset?: string | null;
  language: string;
  productImageUrl: string;
  saveToLibrary: boolean;
  stylePreset?: string | null;
  subtitle?: string | null;
  title?: string | null;
};
export type tasksStartAdGeneratorMutation$variables = {
  input: AdGeneratorInput;
};
export type tasksStartAdGeneratorMutation$data = {
  readonly startAdGenerator: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartAdGeneratorMutation = {
  response: tasksStartAdGeneratorMutation$data;
  variables: tasksStartAdGeneratorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdGeneratorTask",
    "kind": "LinkedField",
    "name": "startAdGenerator",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartAdGeneratorMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "tasksStartAdGeneratorMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "75ca4a0db441f1bd364b1f39a921bec0",
    "id": null,
    "metadata": {},
    "name": "tasksStartAdGeneratorMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartAdGeneratorMutation(\n  $input: AdGeneratorInput!\n) {\n  startAdGenerator(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "8beceae9f1f9c145a33d1c5892528c94";

export default node;
